module.exports = __webpack_public_path__ + "img/waerme-checkmark-a.82814134.svg";